export const platformLabels: { [key in Platform]: string } = {
    TTD: 'TTD',
    Adwords: 'Adwords',
    Facebook: 'Facebook',
    DCM: 'DCM',
};
